import React from "react";
import { Col, Headline, Layout, Row } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { formatDateTime } from "../../utils/formatUtils";
import styles from "./InvestigationTimeline.module.css";
export var InvestigationTimeline = function (_a) {
    var notes = _a.notes, isLoading = _a.isLoading;
    if (isLoading) {
        return (React.createElement(Layout, { className: "padding-top-gutter" },
            React.createElement("em", null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.loading" }))));
    }
    return (React.createElement(Layout, { className: "padding-top-gutter" },
        React.createElement(Headline, { size: "small", margin: "none" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.investigation.notes.title" })),
        notes.length === 0 && (React.createElement(Layout, { className: "padding-top-gutter" },
            React.createElement("em", null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.investigation.notes.empty" })))),
        React.createElement("div", { className: styles.timeline }, notes.map(function (note) { return (React.createElement("div", { key: note.id, className: styles.entry },
            React.createElement("div", { className: styles.dot }),
            React.createElement(Layout, { className: "full padding-bottom-gutter" },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Layout, { className: "display-flex flex-align-items-center" },
                            React.createElement("span", { className: styles.badge },
                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.investigation.channel.note" })),
                            React.createElement("span", { className: styles.meta },
                                formatDateTime(note.createdAt),
                                note.createdByName && (React.createElement(React.Fragment, null, " \u00B7 ".concat(note.createdByName),
                                    note.createdByStatus === "INACTIVE" && (React.createElement(React.Fragment, null,
                                        " ",
                                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.enforcement.timeline.userInactiveSuffix" }))))))))),
                note.text && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement("div", { className: styles.noteText }, note.text))))))); }))));
};
